const randomstop = (maxms = 250) => new Promise(resolve => window.setTimeout(resolve, Math.round(Math.random() * maxms)))

export default randomstop